import { Link } from "react-router-dom";
import "../styles/Footer.css";
import {
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn
} from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-col">
          <h3><img src="/images/access.png"
              alt="ACCESS"
              className="footer-img"/></h3>
          <p>
            Empowering students with quality education and
            result-oriented learning.
          </p>

           {/* Social Icons */}
          <div className="social-icons">
            <a href="https://wa.me/919964585585?text=Hello%20ACCESS%20Team,%20I%20would%20like%20to%20enquire."
            target="_blank"
            rel="noreferrer">
              <FaWhatsapp />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/access.hosa"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>

            <a href="https://linkedin.com" target="_blank" rel="noreferrer">
              <FaLinkedinIn />
            </a>
          </div>          
        </div>

        <div className="footer-col">
          <h4>Courses</h4>
          <ul>
            <li><Link to="/classroom">Tutions</Link></li>
            <li><Link to="/test-series">Test Series</Link></li>
            <li><Link to="/material">Study Material</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/news">news</Link></li>
            <li><Link to="/results">Results</Link></li>
            <li><Link to="/hostel">Hostel</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Support</h4>
          <ul>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/faqs">FAQs</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms & Conditions</Link></li>
          </ul>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© 2025 ACCESS. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
